module.exports = "/assets/data/548380f70fda04427cb5189e0a1e36f2-BS31.data.json";